import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputModule } from '../inputs';
import { EmailComponent } from './components';

@NgModule({
    imports: [
        CommonModule,

        InputModule,
    ],
    declarations: [
        EmailComponent,
    ],
    exports: [
        EmailComponent,
    ],
})

export class EmailModule {}
